
export enum TipoDataFeriadoEnum {
  Fixo = 'Fixo',
  Movel = 'Movel',
}
